module.exports = __webpack_public_path__ + "img/spank.ee576ddc.svg";